import { useTranslation } from 'react-i18next';
import { Alert } from '@seeqdev/qomponents';

interface FormWarningProps {
  warningText: string;
  extraClassNames?: string;
  testId?: string;
}

interface FormWarningNodeProps {
  warningContent: React.ReactNode;
  extraClassNames?: string;
  testId?: string;
}

export const FormWarning: React.FunctionComponent<FormWarningProps> = (props) => {
  const { warningText, extraClassNames, testId } = props;
  const { t } = useTranslation();

  return (
    <Alert dismissible={false} extraClassNames={extraClassNames} variant="warning" testId={testId}>
      {t(warningText)}
    </Alert>
  );
};

export const FormWarningNode: React.FunctionComponent<FormWarningNodeProps> = (props) => {
  const { warningContent, extraClassNames, testId } = props;
  return (
    <Alert dismissible={false} extraClassNames={extraClassNames} variant="warning" testId={testId}>
      {warningContent}
    </Alert>
  );
};
